import { render, staticRenderFns } from "./toggle-header.vue?vue&type=template&id=048a8462&scoped=true"
import script from "./toggle-header.vue?vue&type=script&lang=js"
export * from "./toggle-header.vue?vue&type=script&lang=js"
import style0 from "./toggle-header.vue?vue&type=style&index=0&id=048a8462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048a8462",
  null
  
)

export default component.exports